import { render, staticRenderFns } from "./Solidarnost_online.vue?vue&type=template&id=71827b75&"
import script from "./Solidarnost_online.vue?vue&type=script&lang=js&"
export * from "./Solidarnost_online.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports